import Cookies from "js-cookie";

export const calculateAreaPrice = (area, price) => {
  const areaPrice = area * price;
  return areaPrice;
};

export const isAreaInRange = (area, range) => {
  const { min_ha, max_ha } = range;

  if (max_ha !== undefined) {
    return area >= min_ha && area <= max_ha;
  }

  return area >= min_ha;
};

export const getTotalArea = (properties) => {
  if (!properties) return 0;
  return properties.reduce((total, prop) => total + prop.area, 0);
};

export const mapPropertiesData = (properties) => {
  return properties.map((prop) => {
    const disabled =
      (prop.type == "SBO" && prop.lmID == null) || prop?.status == "broken";

    const designation = disabled
      ? `${prop.designation} - Inte tillgänglig`
      : prop.designation;

    return {
      designation,
      ref: prop.ref,
      area: prop?.area ?? prop?.data?.area,
      type: prop.type,
      lmID: prop?.lmID ?? null,
      disabled,
    };
  });
};

export const saveOrderToCookie = (order) => {
  Cookies.set("drone_order", JSON.stringify(order));
};

export const getOrderFromCookie = () => {
  if (!Cookies.get("drone_order")) {
    return undefined;
  }
  return JSON.parse(Cookies.get("drone_order"));
};

export const clearOrderFromCookie = () => {
  Cookies.remove("drone_order");
};

const stepNames = [
  "order",
  "obstacle_information",
  "payment_selection",
  "thank_you",
];

export const trackDroneCheckoutEvent = (action, currentStep, properties) => {
  const baseTrackingData = {
    category: "drone",
    step: stepNames[currentStep - 1],
  };

  mixpanel.track(`drone_checkout:${action}`, {
    ...baseTrackingData,
    ...properties,
  });

  gtag(
    "event",
    "fe_drone_checkout:" + stepNames[currentStep - 1] + ":" + action,
    {
      method: "site",
    }
  );
};
